import React, { CSSProperties } from "react";
import {
  DatePicker as AntDatePicker,
  DatePickerProps as AntDatePickerProps,
} from "antd";
import locale from "antd/es/date-picker/locale/ko_KR";
import { ReactComponent as Date } from "../../../assets/icons/DatePicker.svg";

type DatePickerProps = AntDatePickerProps & { style?: CSSProperties };

const DatePicker: React.FC<DatePickerProps> = (props: DatePickerProps) => {
  const { style, ...rest } = props;
  return (
    <AntDatePicker
      locale={locale}
      suffixIcon={<Date />}
      style={{
        ...style,
        height: "32px",
      }}
      {...rest}
    />
  );
};

DatePicker.defaultProps = {};
export default DatePicker;
